// import format_mix from '@/mixins/format_mix'
// mixins: [format_mix],

import { parseISO, format, isAfter } from 'date-fns'
import { getCards } from '@/helpers/cards'
import { numFixedUnit } from '@gto/helpers/number-formatting'
import { numRoundTo5bb, numFixed, toggleArr, SNK } from '@/helpers/helpers'
import { numKtoM, numLocale, getPlayerHtmlPosition } from '@/helpers/formating'

const format_mix = {
  methods: {
    getBetHtml({
      a,
      showBetsIn = 'bb',
      simple = false,
      name = false,
      pot_clr = 'currentColor',
      pot_css_class = 'bet-as-pot',
      percent_css_class = 'bet-as-pot',
    }) {
      const raiseBB = a?.raise_amount
      const raisePot = a?.amount_by_pot
      let res = raiseBB
      const bbPot = showBetsIn === 'bb_and_pot' && !simple && raisePot
      const potBb = showBetsIn === 'pot_and_bb' && !simple && raisePot
      const percentSymbol = `<span class='${percent_css_class}'>%</span>`

      if (bbPot) {
        res = `${raiseBB} <span class="${pot_css_class}" style="color:${pot_clr}">(${raisePot}%)</span>`
      } else if (potBb) {
        res = `${raisePot}${percentSymbol} <span class="${pot_css_class}" style="color:${pot_clr}">(${raiseBB})</span>`
      } else if (showBetsIn === 'pot' && raisePot) {
        res = `${raisePot}${percentSymbol}`
      }
      if (name) {
        const dn = a.display_name
        res = `${dn} ${res || ''}`
      }
      return res
    },
    getEvHtml({
      ev,
      pot,
      player, // hero, opponent
      showEvIn = 'ev', // pot, ev_pot,
      showEvIcmIn = 'csd', // cad, cad_pot, table_equity, dollar_ev
      evIcmConverters,
      percent_css_class = 'ev-as-pot_percent',
      ignoreIcmEvIntercept = false,
      unit = '',
      percentUnit = '%',
      dollarUnit = '$',
    }) {
      if (evIcmConverters?.[player]) {
        if (showEvIcmIn === 'csd') {
          ev = this.numFixedUnit(ev, 'ev')
          return `<span>${ev}${unit}</span>`
        }
        if (showEvIcmIn === 'csd_pot') {
          unit = `<span class='${percent_css_class}'>${percentUnit}</span>`
          return `<span>${this.numFixedUnit((ev / pot) * 100, 'ev_pot')}${unit}</span>`
        }
        if (evIcmConverters[player][showEvIcmIn]) {
          const evIcmConverter = evIcmConverters[player][showEvIcmIn]
          ev = evIcmConverter.slope * ev + (ignoreIcmEvIntercept ? 0 : evIcmConverter.intercept)
          if (showEvIcmIn === 'table_equity') {
            unit = `<span class='${percent_css_class}'>${percentUnit}</span>`
            ev = this.numFixedUnit(ev * 100, 'table_equity')
            return `<span>${ignoreIcmEvIntercept && ev > 0 ? '+' : ''}${ev}${unit}</span>`
          }
          if (showEvIcmIn === 'dollar_ev') {
            unit = `<span class='${percent_css_class}'>${dollarUnit}</span>`
            ev = this.numFixedUnit(ev, 'dollar_ev')
            return `<span>${ignoreIcmEvIntercept && ev > 0 ? '+' : ''}${ev}${unit}</span>`
          }
        }
      }

      if (showEvIn === 'ev_pot') {
        unit = `<span class='${percent_css_class}'>${percentUnit}</span>`
        return `<span>${this.numFixedUnit((ev / pot) * 100, 'ev_pot')}${unit}</span>`
      }

      ev = this.numFixedUnit(ev, 'ev')
      return `<span>${ev}${unit}</span>`
    },
    getEvUnitHtml({ showEvIn, showEvIcmIn, evIcmConverters, player }) {
      if (evIcmConverters?.[player]) {
        return this.$t(`units.ev.${showEvIcmIn}`)
      }
      return this.$t(`units.ev.${showEvIn}`)
    },
    getEvPotHtml(showEvIn) {
      return showEvIn === 'pot' ? 'EV/POT%' : 'EV'
    },
    getPlayerHtmlPosition,
    isNull(val) {
      return val === null
    },
    SNK,
    numFixedUnit,
    numFixed,
    numRoundTo5bb,
    numKtoM,
    numLocale,
    getCards,

    // --keep for dev purposes
    // SNK(str, namespace) {
    //   return SNK(str, namespace)
    // },
    // numFixedUnit(num, unit = '') {
    //   return numFixedUnit(num, unit)
    // },
    // numFixed(val, num = 0) {
    //   return Number(val?.toFixed(num))
    // },
    // numRoundTo5bb(n) {
    //   return numRoundTo5bb(n)
    // },

    // --this needs i18n legacy mode off -- which break stuff elsewhere
    formatDate(val, f = 'yyyy-MM-dd') {
      if (val) {
        const parsed = parseISO(val)
        return format(parsed, f)
      }
      return ''
    },
    dateIsAfter(valDate, nowDate = Date.now()) {
      const parsed = parseISO(valDate)
      const res = isAfter(parsed, nowDate)
      return res
    },
    getDateDifference(valDate, nowDate = new Date()) {
      // valDate = '2022-11-25T12:30:00.416838Z'
      valDate = new Date(valDate)
      const diffMs = valDate - nowDate // milliseconds between now & valDate
      const days = Math.floor(diffMs / 86400000) // days
      const hours = Math.floor((diffMs % 86400000) / 3600000) // hours
      const minutes = Math.round(((diffMs % 86400000) % 3600000) / 60000) // minutes

      const mminutesText = this.$tc('common.xxx_minutes', minutes)
      const hoursText = this.$tc('common.xxx_hours', hours)
      const daysText = this.$tc('common.xxx_days', days)
      const res = {
        days,
        hours,
        minutes,
        text: `${
          days
            ? daysText
            : hours
              ? this.$t('common.xxx_hours_xxx_minutes', {
                  xxx_hours: hoursText,
                  xxx_minutes: mminutesText,
                })
              : mminutesText
        }`,
      }
      // console.log(res)
      return res
    },
    formatISODate(
      val,
      opts = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: false,
        minute: false,
        second: false,
        timeZoneName: null,
      },
    ) {
      if (val) {
        const parsed = parseISO(val)
        const options = {
          hour12: false,
          ...(opts.month ? { month: opts.month } : {}),
          ...(opts.day ? { day: opts.day } : {}),
          ...(opts.year ? { year: opts.year } : {}),
          ...(opts?.hour ? { hour: 'numeric' } : {}),
          ...(opts?.minute ? { minute: 'numeric' } : {}),
          ...(opts?.second ? { second: 'numeric' } : {}),
          ...(opts?.timeZoneName ? { timeZoneName: opts?.timeZoneName } : {}),
        }
        const localeStr = parsed.toLocaleString(this.$i18n.locale, options)
        // TODO add correct locales like en-GB now we have en which cause problems
        // const userLocale =
        //   navigator.languages && navigator.languages.length
        //     ? navigator.languages[0]
        //     : navigator.language || 'en-GB'
        // console.log('userLocale', userLocale)
        // const localeStr = parsed.toLocaleString(userLocale, options)

        return localeStr
      }
      return ''
    },
    toggleArr({ arr, item, addTostart = false }) {
      return toggleArr({ arr, item, addTostart })
    },

    // TODO remove
    getActionsByStreet(actions, street) {
      let streetIdx = 0
      const streets = streets
      actions = actions.map(a => {
        const currentStreet = streets[streetIdx]
        if (a.next_street) {
          streetIdx++
        }
        return {
          ...a,
          street: currentStreet,
        }
      })
      const res = actions.filter(a => a.street === street)
      return res
    },
  },
}

export default format_mix
